var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"rounded-full shadow-md flex items-center justify-center",class:[_vm.classes, _vm.linkColor],on:{"click":_vm.onClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }